import { FC } from "react";
import { default as TableMUI } from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

export type SingleTableRowType = { name: string; isVisible: boolean };

type Props = {
  dataSource: any[];
  maxHeight?: number;
  tableKeyToMap: string;
  tableValueToMap: string;
  rows: SingleTableRowType[];
  handleDelete: (item: any) => void;
};

const SingleTable: FC<Props> = ({ rows, dataSource, maxHeight, tableKeyToMap, tableValueToMap, handleDelete }) => {
  return (
    <TableContainer component={Paper} sx={{ maxHeight }}>
      <TableMUI stickyHeader sx={{ minWidth: 500 }} aria-label='sticky table'>
        <TableHead>
          <TableRow>
            {rows?.map(
              ({ name, isVisible }: any) =>
                isVisible && (
                  <TableCell key={name} align='center'>
                    {name}
                  </TableCell>
                )
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataSource?.map((item: any) => (
            <TableRow key={item[tableKeyToMap]} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell component='th' scope='row' style={{ minWidth: 50 }} align='center'>
                {item[tableValueToMap]}
              </TableCell>
              <TableCell align='center'>
                <IconButton aria-label='delete' size='small' onClick={() => handleDelete(item)}>
                  <DeleteIcon fontSize='inherit' />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TableMUI>
    </TableContainer>
  );
};

export default SingleTable;
